import request from '@/utils/request'

export function presignedUrl(data) {
  return request({
    url: '/oss/minio/presignedUrl',
    method: 'get',
    params: data
  })
}
